export default __webpack_public_path__ + "static/media/wireframes.827388ec.png";